import React, {useState, useEffect} from 'react'
import {ModulePanel, ModuleHeader, ModuleBody, ModuleFooter} from 'containers/purchase/modules/module_panel'
import styled from 'styled-components'
import {Label, Input} from 'reactstrap'
import { useTranslation } from 'react-i18next'

export const CouponModule = (props) => {
  const {config, machine, status} = props
  const { t, i18n } = useTranslation()
  const [current, send] = machine
  const { locale } = config
  const { ready } = current.context

  const [coupon, setCoupon] = useState('')

  useEffect(() => {
    send({type: 'COUPON_CHANGE', coupon: coupon})
  }, [coupon])

  return (
    <ModulePanel>
      <ModuleHeader status={status} onClick={() => status == 'completed' ? send('REOPEN_COUPONSTEP') : null}>
        <div>
          <i className="fa fa-percent mr-2"/>
          {i18n.t('coupon_module.title')}
        </div>
      </ModuleHeader>
      <ModuleBody status={status} >
        <div className="d-flex justify-content-center vertical-align-center flex-column">
          <Label>{i18n.t('coupon_module.input_label')}</Label>
          <Input
            placeholder={i18n.t('coupon_module.input_placeholder')} 
            style={{maxWidth: '200px'}}
            value={coupon}
            onChange={(e) => setCoupon(e.target.value)}
          />
        </div>
      </ModuleBody>
      <ModuleFooter {...props}/>
    </ModulePanel>
  )
}

export default CouponModule
